/** Общий AudioContext для Web Audio (beep и разблокировка autoplay) */
let sharedAudioContext: AudioContext | null = null

/**
 * Возвращает общий AudioContext (создаёт при первом вызове).
 * @returns AudioContext или null, если Web Audio API недоступен
 */
export const getSharedAudioContext = (): AudioContext | null => {
  try {
    const AudioContextClass =
      window.AudioContext ??
      (window as Window & { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext

    if (!AudioContextClass) {
      return null
    }

    if (!sharedAudioContext) {
      sharedAudioContext = new AudioContextClass()
    }

    return sharedAudioContext
  } catch {
    return null
  }
}

/**
 * Возобновляет общий AudioContext после жеста пользователя (снимает suspended).
 * @returns Promise, резолвится когда context running или недоступен
 */
export const resumeSharedAudioContext = async (): Promise<void> => {
  const context = getSharedAudioContext()

  if (!context) {
    return
  }

  if (context.state === 'suspended') {
    await context.resume()
  }
}
